"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.settings.systemCommunicationLabel': 'Komunikacja systemowa',
    'whatsapp.settings.systemCommunicationHint': 'Po włączeniu ten bot będzie używany jako domyślny kanał komunikacji systemowej. Tylko jeden bot może pełnić tę rolę jednocześnie.',
    'whatsapp.settings.systemCommunicationGroupLabel': 'Grupa do komunikacji bot-admin',
    'whatsapp.settings.systemCommunicationGroupHint': 'Wybierz grupę, której bot będzie używał do wysyłania wiadomości systemowych do administratorów. Używane, gdy komunikacja systemowa jest włączona.',
    'whatsapp.settings.selectGroup': 'Wybierz grupę',
    'whatsapp.settings.title': 'Komunikacja',
    'whatsapp.settings.description': 'Połącz i zarządzaj kontem WhatsApp poprzez logowanie kodem QR.',
    'whatsapp.settings.status': 'Status połączenia',
    'whatsapp.settings.statusConnected': 'Połączono',
    'whatsapp.settings.statusDisconnected': 'Rozłączono',
    'whatsapp.settings.entityLabel': 'ID Encji',
    'whatsapp.settings.logout': 'Wyloguj',
    'whatsapp.settings.entityIdLabel': 'ID Encji (numer telefonu lub identyfikator)',
    'whatsapp.settings.entityIdPlaceholder': 'Wpisz numer telefonu lub ID encji',
    'whatsapp.settings.startLogin': 'Rozpocznij logowanie',
    'whatsapp.settings.qrTitle': 'Kod QR',
    'whatsapp.settings.qrInstruction': 'Otwórz WhatsApp na telefonie > Ustawienia > Połączone urządzenia > Połącz urządzenie > Zeskanuj ten kod QR.',
    'whatsapp.settings.logsTitle': 'Logi połączenia',
    'whatsapp.settings.clearLogs': 'Wyczyść',
    'whatsapp.settings.noLogs': 'Brak logów. Rozpocznij logowanie, aby zobaczyć logi połączenia.',
    'whatsapp.settings.noSettings': 'Brak konfiguracji numeru telefonu. Utwórz nową, aby rozpocząć.',
    'whatsapp.settings.creator': 'Utworzone przez',
    'whatsapp.settings.pinMessageLabel': 'Przypięta wiadomość',
    'whatsapp.settings.pinMessagePlaceholder': 'Treść wiadomości do przypięcia w konwersacji',
    'whatsapp.settings.pinMessageHint': 'Jeśli wypełnione, ta wiadomość zostanie przypięta dla tego numeru.',
    'whatsapp.settings.pingerLabel': 'Pinger',
    'whatsapp.settings.pingerHint': 'Po włączeniu ten bot okresowo wysyła wiadomości ping, aby utrzymać aktywne połączenie.',
    'whatsapp.settings.phoneTitle': 'Ustawienia numeru telefonu',
    'whatsapp.settings.formTitle': 'Konfiguracja WhatsApp',
    'whatsapp.settings.phoneLabel': 'Numer telefonu',
    'whatsapp.settings.titleLabel': 'Tytuł',
    'whatsapp.settings.titlePlaceholder': 'np. Główne konto, Linia wsparcia...',
    'whatsapp.settings.phonePlaceholder': 'Wprowadź numer telefonu (np. +48123456789)',
    'whatsapp.settings.phoneHint': 'Wprowadź numer telefonu zarejestrowany w WhatsApp, wraz z kodem kraju.',
    'whatsapp.settings.reportEmailLabel': 'Emaile raportów',
    'whatsapp.settings.reportEmailPlaceholder': 'Dodaj adresy email do raportów podsumowujących',
    'whatsapp.settings.reportEmailHint': 'Podsumowania rozmów grupowych będą wysyłane na te adresy email. Naciśnij Enter, aby dodać każdy email.',
    'whatsapp.settings.languageLabel': 'Język bota',
    'whatsapp.settings.languageHint': 'Język używany przez bota podczas odpowiadania na wiadomości i generowania podsumowań.',
    'whatsapp.settings.communicationTypeLabel': 'Typ komunikacji',
    'whatsapp.settings.communicationTypeHint': 'Wybierz kanał komunikacji używany przez tego bota.',
    'whatsapp.settings.communicationType.wa': 'WhatsApp',
    'whatsapp.settings.communicationType.tele': 'Telegram',
    'whatsapp.settings.apiIdLabel': 'Telegram API-ID',
    'whatsapp.settings.apiIdPlaceholder': 'Wprowadź Telegram API-ID',
    'whatsapp.settings.apiIdHint': 'Numeryczne API-ID uzyskane z my.telegram.org.',
    'whatsapp.settings.apiHashLabel': 'Telegram API-Hash',
    'whatsapp.settings.apiHashPlaceholder': 'Wprowadź Telegram API-Hash',
    'whatsapp.settings.apiHashHint': 'Ciąg hash API uzyskany z my.telegram.org.',
    'whatsapp.settings.telegramApiLink': 'Pobierz API ID i Hash dla konta Telegram',
    'whatsapp.settings.telegramAuthTitle': 'Uwierzytelnianie Telegram',
    'whatsapp.settings.telegramCodeInstruction': 'Wprowadź kod weryfikacyjny wysłany na Twoje konto Telegram.',
    'whatsapp.settings.telegramCodePlaceholder': 'Kod',
    'whatsapp.settings.telegramCodeSubmit': 'Prześlij kod',
    'whatsapp.settings.telegramPasswordInstruction': 'Wprowadź hasło uwierzytelniania dwuskładnikowego Twojego konta Telegram.',
    'whatsapp.settings.telegramPasswordPlaceholder': 'Hasło',
    'whatsapp.settings.telegramPasswordSubmit': 'Prześlij hasło',
    'whatsapp.settings.botResponseConditionLabel': 'Warunek odpowiedzi bota',
    'whatsapp.settings.botResponseConditionPlaceholder': 'Opisz kiedy bot powinien odpowiadać, np. "Pytania o godziny otwarcia, ceny lub usługi"',
    'whatsapp.settings.botResponseConditionHint': 'Bot będzie odpowiadał na wiadomości użytkowników pasujące do tego warunku. Pozostaw puste, aby wyłączyć automatyczne odpowiedzi.',
    'whatsapp.settings.avatarLabel': 'Awatar',
    'whatsapp.settings.selectAvatar': '-- Wybierz awatara --',
    'whatsapp.settings.avatarHint': 'Wybierz awatara do odpowiedzi AI na tym numerze WhatsApp.',
    'whatsapp.settings.save': 'Zapisz ustawienia',
    'whatsapp.settings.startAgent': 'Uruchom agenta',
    'whatsapp.settings.stopAgent': 'Zatrzymaj agenta',
    'whatsapp.settings.agentRunning': 'Agent uruchomiony',
    'whatsapp.settings.agentInitializing': 'Inicjalizacja...',
    'whatsapp.settings.agent_status_active': 'Aktywny',
    'whatsapp.settings.agent_status_initializing': 'Inicjalizacja',
    'whatsapp.settings.agent_status_inactive': 'Nieaktywny',
    'whatsapp.settings.pop3.title': 'Raportowanie e-mail',
    'whatsapp.settings.pop3.description': 'Skonfiguruj serwery poczty do pobierania i monitorowania wiadomości e-mail.',
    'whatsapp.settings.pop3.add': 'Dodaj serwer',
    'whatsapp.settings.pop3.empty': 'Brak skonfigurowanych serwerów e-mail. Kliknij "Dodaj serwer", aby utworzyć nowy.',
    'whatsapp.settings.pop3.untitled': 'Serwer bez nazwy',
    'whatsapp.settings.pop3.host.label': 'Host serwera',
    'whatsapp.settings.pop3.host.placeholder': 'pop.example.com',
    'whatsapp.settings.pop3.port.label': 'Port',
    'whatsapp.settings.pop3.port.placeholder': '995',
    'whatsapp.settings.pop3.username.label': 'Nazwa użytkownika',
    'whatsapp.settings.pop3.username.placeholder': 'Wprowadź adres e-mail lub nazwę użytkownika',
    'whatsapp.settings.pop3.password.label': 'Hasło',
    'whatsapp.settings.pop3.password.placeholder': 'Wprowadź hasło',
    'whatsapp.settings.pop3.useTls.label': 'Użyj TLS/SSL',
    'whatsapp.settings.pop3.enabled.label': 'Włączony',
    'whatsapp.settings.pop3.save': 'Zapisz ustawienia raportowania e-mail',
    'whatsapp.settings.pop3.isGmail.label': 'Gmail',
    'whatsapp.settings.pop3.isGmail.hint': 'Włącz, aby połączyć się przez Google OAuth zamiast danych IMAP.',
    'whatsapp.settings.pop3.gmail.info': 'Kliknij "Połącz Gmail", aby autoryzować dostęp do skrzynki Gmail przez Google OAuth.',
    'whatsapp.settings.pop3.configure': 'Konfiguruj raportowanie e-mail',
    'whatsapp.settings.pop3.enabled.yes': 'Włączony',
    'whatsapp.settings.pop3.enabled.no': 'Wyłączony',
    'whatsapp.settings.pop3.actions': 'Akcje',
    'whatsapp.settings.pop3.remove': 'Usuń',
    'whatsapp.settings.pop3.remove.failed': 'Nie udało się usunąć konta e-mail.',
    'whatsapp.settings.pop3.remove.confirm': 'Czy na pewno chcesz usunąć to konto e-mail?',
    'whatsapp.settings.pop3.removed': 'Konto e-mail zostało usunięte.',
    'whatsapp.settings.pop3.saved': 'Ustawienia raportowania e-mail zapisane pomyślnie.',
    'whatsapp.settings.pop3.host.required': 'Host serwera jest wymagany.',
    'whatsapp.settings.pop3.gmail.label': 'Gmail',
    'whatsapp.settings.pop3.gmail.connect': 'Połącz z Gmail',
    'whatsapp.settings.pop3.gmail.disconnect': 'Rozłącz Gmail',
    'whatsapp.settings.pop3.gmail.connected': 'Gmail połączony',
    'whatsapp.settings.pop3.gmail.notConnected': 'Gmail niepołączony',
    'whatsapp.settings.pop3.gmail.authFailed': 'Uwierzytelnianie Gmail nie powiodło się.',
    'whatsapp.settings.pop3.gmail.disconnected': 'Gmail rozłączony pomyślnie.',
    'whatsapp.settings.pop3.gmail.disconnectFailed': 'Nie udało się rozłączyć Gmail.',
    'whatsapp.settings.pop3.gmail.authWindowOpened': 'Otwarto okno uwierzytelniania Gmail.',
};
